export const OPENED_PAGE_PARAM = 'openedPage';
